(function () {
  var MAX_RECENT = 8;
  var STORAGE_KEY = 'liveShoppingRecent';

  function initLogin() {
    var loginBox = document.querySelector('[data-live-login]');
    var appBox = document.querySelector('[data-live-app]');
    var emailInput = document.querySelector('[data-login-email]');
    var passwordInput = document.querySelector('[data-login-password]');
    var loginButton = document.querySelector('[data-login-button]');
    var loginError = document.querySelector('[data-login-error]');

    if (!window.firebase || !window.firebaseConfig) {
      loginError.textContent = 'Firebase no está configurado.';
      loginError.hidden = false;
      return;
    }

    if (!firebase.apps.length) firebase.initializeApp(window.firebaseConfig);

    var alreadyInitialized = false;

    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        loginBox.hidden = true;
        appBox.hidden = false;
        if (!alreadyInitialized) {
          alreadyInitialized = true;
          initControl(appBox);
        }
      } else {
        loginBox.hidden = false;
        appBox.hidden = true;
      }
    });

    loginButton.addEventListener('click', function () {
      loginError.hidden = true;
      firebase.auth()
        .signInWithEmailAndPassword(emailInput.value.trim(), passwordInput.value)
        .catch(function (err) {
          loginError.textContent = 'Correo o contraseña incorrectos.';
          loginError.hidden = false;
        });
    });

    passwordInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') loginButton.click();
    });
  }

  function initControl(root) {
    var searchInput = root.querySelector('[data-live-search-input]');
    var searchResults = root.querySelector('[data-live-search-results]');
    var grid = root.querySelector('[data-live-recent-grid]');
    var currentLabel = root.querySelector('[data-live-control-current]');
    var emptyMsg = root.querySelector('[data-live-empty]');
    var liveProductBox = root.querySelector('[data-live-product]');
    var liveImage = root.querySelector('[data-live-product-image]');
    var liveTitle = root.querySelector('[data-live-product-title]');
    var livePrice = root.querySelector('[data-live-product-price]');
    var liveOptions = root.querySelector('[data-live-product-options]');

    var recent = loadRecent();

    // --- Conexión a Firebase ---
    var db = null;
    if (window.firebase && window.firebaseConfig) {
      if (!firebase.apps.length) firebase.initializeApp(window.firebaseConfig);
      db = firebase.database();
    }

    function syncToFirebase(payload) {
      if (!db) return;
      db.ref('liveShopping/current').set(payload);
      db.ref('liveShopping/isLive').set(true);
    }

    function loadRecent() {
      try {
        var saved = localStorage.getItem(STORAGE_KEY);
        return saved ? JSON.parse(saved) : [];
      } catch (e) {
        return [];
      }
    }

    function saveRecent() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
      } catch (e) {}
    }

    // --- Búsqueda en vivo (usa el buscador nativo de Shopify) ---
    var searchTimer = null;

    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      clearTimeout(searchTimer);

      if (query.length < 2) {
        searchResults.hidden = true;
        return;
      }

      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderSearchResults(products);
          })
          .catch(function () {
            searchResults.hidden = true;
          });
      }, 300);
    });

    // Cierra los resultados si se hace clic fuera
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) return;
      if (!searchResults.contains(e.target) && e.target !== searchInput) {
        searchResults.hidden = true;
      }
    });

    function renderSearchResults(products) {
      if (!products.length) {
        searchResults.innerHTML = '<p class="live-control__search-empty">Sin resultados</p>';
        searchResults.hidden = false;
        return;
      }

      searchResults.innerHTML = products.map(function (p) {
        var image = p.image || '';
        var formattedPrice = '$' + p.price;
        return (
          '<div class="live-control__search-result" data-search-result' +
          ' data-id="' + p.id + '"' +
          ' data-title="' + escapeHtml(p.title) + '"' +
          ' data-price="' + escapeHtml(formattedPrice) + '"' +
          ' data-image="' + escapeHtml(image) + '"' +
          ' data-url="' + escapeHtml(p.url) + '"' +
          '>' +
          (image ? '<img src="' + image + '" alt="">' : '<div class="live-control__search-result-noimg"></div>') +
          '<div class="live-control__search-result-info">' +
          '<p class="live-control__search-result-title">' + escapeHtml(p.title) + '</p>' +
          '<p class="live-control__search-result-price">' + escapeHtml(formattedPrice) + '</p>' +
          '</div>' +
          '</div>'
        );
      }).join('');

      searchResults.hidden = false;

      searchResults.querySelectorAll('[data-search-result]').forEach(function (el) {
        el.addEventListener('click', function () {
          selectProduct({
            id: el.dataset.id,
            title: el.dataset.title,
            price: el.dataset.price,
            image: el.dataset.image,
            url: el.dataset.url
          });
          searchResults.hidden = true;
          searchInput.value = '';
        });
      });
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    // --- Selección de producto: marca como actual + actualiza recientes ---
    function selectProduct(product) {
      // Quita duplicado si ya estaba en la lista, para moverlo al frente
      recent = recent.filter(function (p) { return String(p.id) !== String(product.id); });
      recent.unshift(product);
      if (recent.length > MAX_RECENT) {
        recent = recent.slice(0, MAX_RECENT);
      }
      saveRecent();
      renderRecent();
      setCurrent(product);

      // Se sincroniza en tiempo real con la página que ven los clientes
      syncToFirebase({
        productId: String(product.id),
        variantId: null, // se completa en cuanto carguen las variantes reales
        title: product.title,
        price: product.price,
        image: product.image
      });
    }

    function setCurrent(product) {
      currentLabel.textContent = product.title;
      grid.querySelectorAll('[data-recent-item]').forEach(function (el) {
        el.classList.toggle('is-live', String(el.dataset.id) === String(product.id));
        var btn = el.querySelector('[data-live-control-button]');
        if (btn) btn.textContent = String(el.dataset.id) === String(product.id) ? '● En pantalla' : 'Poner en pantalla';
      });
      loadFullProduct(product);
    }

    // --- Carga la info completa del producto (variantes reales) ---
    function loadFullProduct(product) {
      liveProductBox.hidden = false;
      liveTitle.textContent = product.title;
      livePrice.textContent = product.price || '';
      liveImage.src = product.image || '';
      liveOptions.innerHTML = '<p class="live-control__search-empty">Cargando variantes…</p>';

      if (!product.url) return;
      var jsonUrl = product.url.split('?')[0] + '.js';

      fetch(jsonUrl)
        .then(function (res) { return res.json(); })
        .then(function (fullProduct) {
          renderVariantOptions(fullProduct);
        })
        .catch(function () {
          liveOptions.innerHTML = '';
        });
    }

    function buildOptionsText(options, selection) {
      return options.map(function (opt, i) {
        return getOptionName(opt) + ': ' + selection[i];
      }).join(' · ');
    }

    // Shopify a veces manda cada opción como texto ("Talla") y a veces
    // como un objeto ({ name: "Talla", position: 1 }) según la versión
    // de la tienda — esto toma el nombre real venga como venga.
    function getOptionName(opt) {
      if (opt && typeof opt === 'object') return opt.name || '';
      return opt;
    }

    function renderVariantOptions(fullProduct) {
      var selected = {}; // { optionIndex: value }
      var options = fullProduct.options || [];

      // Si el producto no tiene variantes reales (solo "Default Title")
      if (!options.length || (options.length === 1 && getOptionName(options[0]) === 'Title')) {
        liveOptions.innerHTML = '';
        var onlyVariant = fullProduct.variants[0];
        if (onlyVariant) {
          livePrice.textContent = formatMoney(onlyVariant.price);
          syncToFirebase({
            productId: String(fullProduct.id),
            variantId: String(onlyVariant.id),
            title: fullProduct.title,
            price: formatMoney(onlyVariant.price),
            image: fullProduct.featured_image,
            optionsText: '',
            available: !!onlyVariant.available
          });
        }
        return;
      }

      function findMatchingVariant() {
        return fullProduct.variants.find(function (v) {
          return options.every(function (optName, i) {
            var key = 'option' + (i + 1);
            return !(i in selected) || v[key] === selected[i];
          });
        });
      }

      function isValueAvailable(optionIndex, value) {
        var testSelection = Object.assign({}, selected);
        testSelection[optionIndex] = value;
        return fullProduct.variants.some(function (v) {
          return options.every(function (optName, i) {
            var key = 'option' + (i + 1);
            return !(i in testSelection) || v[key] === testSelection[i];
          }) && v.available;
        });
      }

      function render() {
        liveOptions.innerHTML = options.map(function (opt, i) {
          var optName = getOptionName(opt);
          var values = fullProduct.options_with_values
            ? fullProduct.options_with_values[i].values
            : uniqueValues(fullProduct.variants, i);

          return (
            '<div class="live-control__option-group">' +
            '<p class="live-control__option-group-label">' + escapeHtml(optName) + '</p>' +
            '<div class="live-control__option-values">' +
            values.map(function (val) {
              var isSelected = selected[i] === val;
              var isAvailable = isValueAvailable(i, val);
              return (
                '<button type="button" class="live-control__option-value' +
                (isSelected ? ' is-selected' : '') + '"' +
                (isAvailable ? '' : ' disabled') +
                ' data-option-index="' + i + '" data-option-value="' + escapeHtml(val) + '">' +
                escapeHtml(val) + '</button>'
              );
            }).join('') +
            '</div></div>'
          );
        }).join('');

        liveOptions.querySelectorAll('.live-control__option-value').forEach(function (btn) {
          btn.addEventListener('click', function () {
            selected[btn.dataset.optionIndex] = btn.dataset.optionValue;
            render();
            var variant = findMatchingVariant();
            if (variant) {
              livePrice.textContent = formatMoney(variant.price);
              var img = variant.featured_image ? variant.featured_image.src : liveImage.src;
              if (variant.featured_image) liveImage.src = img;
              syncToFirebase({
                productId: String(fullProduct.id),
                variantId: String(variant.id),
                title: fullProduct.title,
                price: formatMoney(variant.price),
                image: img,
                optionsText: buildOptionsText(options, selected),
                available: !!variant.available
              });
            }
          });
        });
      }

      // Preselecciona la primera variante disponible
      var firstAvailable = fullProduct.variants.find(function (v) { return v.available; }) || fullProduct.variants[0];
      if (firstAvailable) {
        options.forEach(function (optName, i) {
          selected[i] = firstAvailable['option' + (i + 1)];
        });
        livePrice.textContent = formatMoney(firstAvailable.price);
        syncToFirebase({
          productId: String(fullProduct.id),
          variantId: String(firstAvailable.id),
          title: fullProduct.title,
          price: formatMoney(firstAvailable.price),
          image: (firstAvailable.featured_image && firstAvailable.featured_image.src) || fullProduct.featured_image,
          optionsText: buildOptionsText(options, selected),
          available: !!firstAvailable.available
        });
      }

      render();
    }

    function uniqueValues(variants, optionIndex) {
      var seen = [];
      variants.forEach(function (v) {
        var val = v['option' + (optionIndex + 1)];
        if (val && seen.indexOf(val) === -1) seen.push(val);
      });
      return seen;
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function renderRecent() {
      if (!recent.length) {
        grid.innerHTML = '';
        grid.appendChild(emptyMsg);
        return;
      }

      grid.innerHTML = recent.map(function (p) {
        return (
          '<div class="live-control__card" data-recent-item data-id="' + p.id + '">' +
          '<div class="live-control__card-image">' +
          (p.image ? '<img src="' + p.image + '" alt="">' : '') +
          '</div>' +
          '<p class="live-control__card-title">' + escapeHtml(p.title) + '</p>' +
          '<p class="live-control__card-price">' + escapeHtml(p.price) + '</p>' +
          '<button type="button" class="live-control__card-button" data-live-control-button>Poner en pantalla</button>' +
          '</div>'
        );
      }).join('');

      grid.querySelectorAll('[data-recent-item]').forEach(function (el) {
        el.querySelector('[data-live-control-button]').addEventListener('click', function () {
          var product = recent.find(function (p) { return String(p.id) === el.dataset.id; });
          if (product) selectProduct(product);
        });
      });
    }

    renderRecent();

    // --- Chat en vivo: últimos 6 mensajes, con botones para silenciar
    // o banear al usuario que los mandó (usando su número, no su
    // nombre, para identificarlo de forma inequívoca). ---
    var chatBox = root.querySelector('[data-live-control-chat]');

    if (db && chatBox) {
      db.ref('liveShopping/chat').limitToLast(6).on('value', function (snapshot) {
        var messages = [];
        snapshot.forEach(function (child) { messages.push(child.val()); });
        messages.reverse(); // el más reciente arriba

        if (!messages.length) {
          chatBox.innerHTML = '<p class="live-control__empty">Aún no hay mensajes.</p>';
          return;
        }

        chatBox.innerHTML = messages.map(function (m) {
          return (
            '<div class="live-control__chat-msg" data-chat-msg data-user-id="' + escapeHtmlAttr(m.userId || '') + '">' +
            '<span class="live-control__chat-msg-text">' +
            '<span class="live-control__chat-msg-number">#' + (m.number || '?') + '</span>' +
            escapeHtml(m.name) + ': ' + escapeHtml(m.text) +
            '</span>' +
            '<span class="live-control__chat-msg-actions">' +
            '<button type="button" data-mute-btn>Silenciar</button>' +
            '<button type="button" data-ban-btn>Banear</button>' +
            '</span>' +
            '</div>'
          );
        }).join('');

        chatBox.querySelectorAll('[data-chat-msg]').forEach(function (msgEl) {
          var userId = msgEl.dataset.userId;
          if (!userId) return;

          var muteBtn = msgEl.querySelector('[data-mute-btn]');
          var banBtn = msgEl.querySelector('[data-ban-btn]');

          // Marca visualmente si el usuario ya está silenciado/baneado
          db.ref('liveShopping/users/' + userId).once('value', function (snap) {
            var u = snap.val();
            if (!u) return;
            if (u.muted) { muteBtn.classList.add('is-active'); muteBtn.textContent = 'Silenciado ✓'; }
            if (u.banned) { banBtn.classList.add('is-active'); banBtn.textContent = 'Baneado ✓'; msgEl.classList.add('is-flagged'); }
          });

          muteBtn.addEventListener('click', function () {
            var newState = !muteBtn.classList.contains('is-active');
            db.ref('liveShopping/users/' + userId + '/muted').set(newState);
            muteBtn.classList.toggle('is-active', newState);
            muteBtn.textContent = newState ? 'Silenciado ✓' : 'Silenciar';
          });

          banBtn.addEventListener('click', function () {
            var newState = !banBtn.classList.contains('is-active');
            db.ref('liveShopping/users/' + userId + '/banned').set(newState);
            banBtn.classList.toggle('is-active', newState);
            banBtn.textContent = newState ? 'Baneado ✓' : 'Banear';
            msgEl.classList.toggle('is-flagged', newState);
          });
        });
      });
    }

    function escapeHtmlAttr(str) {
      return escapeHtml(str).replace(/"/g, '&quot;');
    }

    // --- Terminar transmisión: borra el producto en pantalla y el
    // historial de chat. El registro de usuarios (nombres, números,
    // silenciados, baneados) NO se toca — se mantiene para el próximo
    // live. ---
    var endLiveBtn = root.querySelector('[data-live-end-btn]');
    var returnsInput = root.querySelector('[data-live-returns-input]');

    if (endLiveBtn && db) {
      endLiveBtn.addEventListener('click', function () {
        var confirmed = window.confirm('¿Terminar la transmisión? Esto borra el producto en pantalla y el chat (los usuarios registrados no se pierden).');
        if (!confirmed) return;

        db.ref('liveShopping/isLive').set(false, function (error) {
          if (error) alert('Error al terminar el live: ' + error.message);
        });
        db.ref('liveShopping/current').remove();
        db.ref('liveShopping/chat').remove();

        if (returnsInput && returnsInput.value) {
          db.ref('liveShopping/returnsAt').set(returnsInput.value, function (error) {
            if (error) alert('Error al guardar la fecha de regreso: ' + error.message);
          });
        } else {
          db.ref('liveShopping/returnsAt').remove();
        }

        currentLabel.textContent = 'Ninguno';
        liveProductBox.hidden = true;
        chatBox.innerHTML = '<p class="live-control__empty">Aún no hay mensajes.</p>';
      });
    }

    // --- Iniciar transmisión: se pega el link completo de YouTube y
    // se extrae el ID automáticamente (funciona con cualquier formato
    // de link: watch?v=, youtu.be/, live/, etc.) ---
    var startLiveBtn = root.querySelector('[data-live-start-btn]');
    var youtubeInput = root.querySelector('[data-live-youtube-input]');
    var startStatus = root.querySelector('[data-live-start-status]');

    function extractYouTubeId(url) {
      var patterns = [
        /(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
        /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/,
        /(?:youtube\.com\/live\/)([a-zA-Z0-9_-]{11})/,
        /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/
      ];
      for (var i = 0; i < patterns.length; i++) {
        var match = url.match(patterns[i]);
        if (match) return match[1];
      }
      // Si ya es solo el ID (11 caracteres, sin espacios ni símbolos de link)
      if (/^[a-zA-Z0-9_-]{11}$/.test(url.trim())) return url.trim();
      return null;
    }

    if (startLiveBtn && db) {
      startLiveBtn.addEventListener('click', function () {
        var url = youtubeInput.value.trim();
        var id = extractYouTubeId(url);

        if (!id) {
          startStatus.textContent = '❌ No se reconoció ese link. Pega el link completo de tu YouTube Live.';
          return;
        }

        startStatus.textContent = 'Guardando…';

        var writesRemaining = 3;
        function onWriteDone(error) {
          if (error) {
            startStatus.textContent = '❌ Error al guardar: ' + error.message + ' (revisa las reglas de Firebase)';
            return;
          }
          writesRemaining--;
          if (writesRemaining === 0) {
            startStatus.textContent = '✅ Live iniciado con el video: ' + id;
          }
        }

        db.ref('liveShopping/youtubeId').set(id, onWriteDone);
        db.ref('liveShopping/isLive').set(true, onWriteDone);
        db.ref('liveShopping/returnsAt').remove(onWriteDone);
      });
    }
  }

  function initAll() {
    initLogin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
